<template>
  <div v-if="viewdata.type === 'fileaccesschange'">
    <div class="my-4" v-for="(v,k) in viewdata.data" :key="k">
      <v-row>
        <v-col cols="12" sm="3" class="d-flex">
          <div class="details-label font-weight-medium">
            <span>{{viewdata.__reportingunit_detail[v.rucode].code}} -</span><br>
            <span>{{viewdata.__reportingunit_detail[v.rucode].name}}</span>
          </div>
        </v-col>
        <v-col>
          <div class="details-label font-weight-medium">
            <div class="d-flex flex-column gap-3">
              <div v-if="(v?.submitter || []).length > 0" class="d-flex flex-column gap-2">
                <div class="font-weight-regular">{{$nova.labelsName('approvals_page','commentary_local_preparer_label','Local Preparer')}}(s)</div>
                <div class="d-flex gap-2">
                  <v-chip  class="ru-info-chip"  :key="vk" v-for="(vv,vk) in (v?.submitter || [])">
                    <span class="details-value textLowercase">{{viewdata.__userlist[vv]?.email || "Unknown"}}</span>
                  </v-chip>
                </div>
              </div>
              <div v-if="(v?.approver || []).length > 0" class="d-flex flex-column gap-2">
                <div class="font-weight-regular">{{ $nova.labelsName('approvals_page','commentary_local_approver_label','Local Approver') }}(s)</div>
                <div class="d-flex gap-2">
                  <v-chip  class="ru-info-chip"  :key="vk" v-for="(vv,vk) in (v?.approver || [])">
                    <span class="details-value textLowercase">{{viewdata.__userlist[vv]?.email || "Unknown"}}</span>
                  </v-chip>
                </div>
              </div>
              <div v-if="(v?.manager || []).length > 0" class="d-flex flex-column gap-2">
                <div class="font-weight-regular">Manager(s)</div>
                <div class="d-flex gap-2">
                  <v-chip  class="ru-info-chip"  :key="vk" v-for="(vv,vk) in (v?.manager || [])">
                    <span class="details-value textLowercase">{{viewdata.__userlist[vv]?.email || "Unknown"}}</span>
                  </v-chip>
                </div>
              </div>
              <div v-if="(v?.regional_approver || []).length > 0" class="d-flex flex-column gap-2">
                <div class="font-weight-regular">{{ $nova.labelsName('approvals_page','commentary_regional_approver_label','Regional Approver') }}(s)</div>
                <div class="d-flex gap-2">
                  <v-chip class="ru-info-chip"  :key="vk"
                    v-for="(vv,vk) in (v?.regional_approver || [])">
                    <span class="details-value textLowercase">{{viewdata.__userlist[vv]?.email || "Unknown"}}</span>
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      

      <v-divider class="my-2" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApprovalFileAccessChange',
  props: {
    viewdata: {
      type: Object,
      required: true
    }
  }
}
</script>
